import type { ISxProps } from '@/CommonComponents/types'

export const gitlabOutlinedIcon = ({ sx, color }: { sx?: ISxProps; color?: string }) => {
  // Filter out null values from sx to avoid TypeScript errors
  const filteredSx = sx ? Object.fromEntries(Object.entries(sx).filter(([_, value]) => value !== null)) : {}

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      style={{ width: '1em', height: '1em', ...filteredSx }}
      color={color}
    >
      {/* eslint-disable-next-line max-len */}
      <path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18L7.44 9H16.56l2.93-6.82a.42.42 0 0 1 .11-.18.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51 1.22 3.78a.84.84 0 0 1-.3.94z" />
    </svg>
  )
}
